import famousCyclingQuotesData from '@/js/data/famousCyclingQuotes.json';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export function useCyclingQuotes() {
    const { locale } = useI18n();

    // Get quotes for current language
    const currentQuotes = computed(() => {
        const currentLang = locale.value || 'fr';
        return (
            famousCyclingQuotesData[currentLang] || famousCyclingQuotesData.fr
        );
    });

    // Get all available categories for current language
    const availableCategories = computed(() => {
        if (!currentQuotes.value) return [];
        const categories = [
            ...new Set(currentQuotes.value.map(quote => quote.category)),
        ];
        return categories.sort();
    });

    // Get quotes by category
    const getQuotesByCategory = category => {
        if (!currentQuotes.value) return [];
        return currentQuotes.value.filter(quote => quote.category === category);
    };

    // Get random quote
    const getRandomQuote = (category = null) => {
        let quotesToChooseFrom = currentQuotes.value;

        if (category) {
            quotesToChooseFrom = getQuotesByCategory(category);
        }

        if (!quotesToChooseFrom || quotesToChooseFrom.length === 0) {
            return null;
        }

        const randomIndex = Math.floor(
            Math.random() * quotesToChooseFrom.length,
        );
        return quotesToChooseFrom[randomIndex];
    };

    // Get multiple random quotes
    const getRandomQuotes = (count = 5, category = null) => {
        let quotesToChooseFrom = currentQuotes.value;

        if (category) {
            quotesToChooseFrom = getQuotesByCategory(category);
        }

        if (!quotesToChooseFrom || quotesToChooseFrom.length === 0) {
            return [];
        }

        // Shuffle array and take first 'count' items
        const shuffled = [...quotesToChooseFrom].sort(
            () => 0.5 - Math.random(),
        );
        return shuffled.slice(0, Math.min(count, shuffled.length));
    };

    // Search quotes by text or author
    const searchQuotes = searchTerm => {
        if (!currentQuotes.value || !searchTerm) return [];

        const term = searchTerm.toLowerCase();
        return currentQuotes.value.filter(
            quote =>
                quote.text.toLowerCase().includes(term) ||
                quote.author.toLowerCase().includes(term),
        );
    };

    return {
        currentQuotes,
        availableCategories,
        getQuotesByCategory,
        getRandomQuote,
        getRandomQuotes,
        searchQuotes,
    };
}
